import React, { PropTypes } from 'react/addons';

import createRange from 'ofs/utils/range';

const DayHeaders = React.createClass({
  propTypes: {
    weekStarts: PropTypes.number.isRequired,
    children: PropTypes.func.isRequired,
  },

  render() {
    const { weekStarts, children } = this.props;
    const days = createRange(weekStarts, 7)
      .concat(createRange(0, weekStarts));

    return (
      <thead>
        <tr>
          {days.map((dayIndex) => (
            <th className="ofs-Calendar__WeekdayHeading" key={dayIndex}>{children(dayIndex)}</th>
          ))}
        </tr>
      </thead>
    );
  }
});

export default DayHeaders;



/** WEBPACK FOOTER **
 ** ./static/js/onefinestay/components/Calendar/DayHeaders.jsx
 **/